import {
    SilSubsystemBlock,
    QidProduct,
} from "server/models"
import {
    OrderType,
    QidCalculationMethod,
} from "client/utils"
import {
    SilDeviceNestedType,
    SilDeviceType,
    SilDeviceList,
    SilDeviceFilters,
    QidProductList,
    QidProductFilters,
    ResultDatapointListType,
} from "client/store"


export type ModelTargetType = "subsystem" | "safetyFunction"
export type SilModelDeviceOnSelect = (device: SilDeviceNestedType | SilSubsystemBlock) => void

export type SilModelDevicesQidExpanded = {
    productIds?: readonly number[]
    modelIds?: readonly number[]
    safetyFunctionIds?: readonly number[]
    optionIds?: readonly number[]
}

export interface SilModelDevicesState {
    activeTab: string
    modelTarget: ModelTargetType
    onSelect: SilModelDeviceOnSelect

    accountDevices: {
        deviceList: SilDeviceList
        deviceIds: readonly number[]
        sortColumn: keyof SilDeviceType
        sortOrder: OrderType
        filters: SilDeviceFilters
    }

    accountSubsystems: {
        deviceList: SilDeviceList
        deviceIds: readonly number[]
        sortColumn: keyof SilDeviceType
        sortOrder: OrderType
        filters: SilDeviceFilters
    }

    projectDevices: {
        deviceList: SilDeviceList
        deviceIds: readonly number[]
        sortColumn: keyof SilDeviceType
        sortOrder: OrderType
        filters: SilDeviceFilters
    }

    projectSubsystems: {
        deviceList: SilDeviceList
        deviceIds: readonly number[]
        sortColumn: keyof SilDeviceType
        sortOrder: OrderType
        filters: SilDeviceFilters
    }

    qidProducts: {
        productList: QidProductList
        productIds: readonly number[]
        sortColumn: keyof QidProduct
        sortOrder: OrderType
        filters: QidProductFilters

        expanded: SilModelDevicesQidExpanded

        datapointList: { [productId: number]: ResultDatapointListType }
        calculationMethod: QidCalculationMethod
    }
}

export const SIL_MODEL_DEVICES_ACTIVE_TAB = "SIL_MODEL_DEVICES_ACTIVE_TAB"
export const SIL_MODEL_DEVICES_MODEL_TARGET = "SIL_MODEL_DEVICES_MODEL_TARGET"
export const SIL_MODEL_DEVICES_ON_SELECT = "SIL_MODEL_DEVICES_ON_SELECT"

export const SIL_MODEL_DEVICES_ACCOUNT_DEVICE_LIST = "SIL_MODEL_DEVICES_ACCOUNT_DEVICE_LIST"
export const SIL_MODEL_DEVICES_ACCOUNT_DEVICE_IDS = "SIL_MODEL_DEVICES_ACCOUNT_DEVICE_IDS"
export const SIL_MODEL_DEVICES_ACCOUNT_DEVICE_SORT = "SIL_MODEL_DEVICES_ACCOUNT_DEVICE_SORT"
export const SIL_MODEL_DEVICES_ACCOUNT_DEVICE_FILTERS = "SIL_MODEL_DEVICES_ACCOUNT_DEVICE_FILTERS"

export const SIL_MODEL_DEVICES_ACCOUNT_SUBSYSTEM_LIST = "SIL_MODEL_DEVICES_ACCOUNT_SUBSYSTEM_LIST"
export const SIL_MODEL_DEVICES_ACCOUNT_SUBSYSTEM_IDS = "SIL_MODEL_DEVICES_ACCOUNT_SUBSYSTEM_IDS"
export const SIL_MODEL_DEVICES_ACCOUNT_SUBSYSTEM_SORT = "SIL_MODEL_DEVICES_ACCOUNT_SUBSYSTEM_SORT"
export const SIL_MODEL_DEVICES_ACCOUNT_SUBSYSTEM_FILTERS = "SIL_MODEL_DEVICES_ACCOUNT_SUBSYSTEM_FILTERS"

export const SIL_MODEL_DEVICES_PROJECT_DEVICE_LIST = "SIL_MODEL_DEVICES_PROJECT_DEVICE_LIST"
export const SIL_MODEL_DEVICES_PROJECT_DEVICE_IDS = "SIL_MODEL_DEVICES_PROJECT_DEVICE_IDS"
export const SIL_MODEL_DEVICES_PROJECT_DEVICE_SORT = "SIL_MODEL_DEVICES_PROJECT_DEVICE_SORT"
export const SIL_MODEL_DEVICES_PROJECT_DEVICE_FILTERS = "SIL_MODEL_DEVICES_PROJECT_DEVICE_FILTERS"

export const SIL_MODEL_DEVICES_PROJECT_SUBSYSTEM_LIST = "SIL_MODEL_DEVICES_PROJECT_SUBSYSTEM_LIST"
export const SIL_MODEL_DEVICES_PROJECT_SUBSYSTEM_IDS = "SIL_MODEL_DEVICES_PROJECT_SUBSYSTEM_IDS"
export const SIL_MODEL_DEVICES_PROJECT_SUBSYSTEM_SORT = "SIL_MODEL_DEVICES_PROJECT_SUBSYSTEM_SORT"
export const SIL_MODEL_DEVICES_PROJECT_SUBSYSTEM_FILTERS = "SIL_MODEL_DEVICES_PROJECT_SUBSYSTEM_FILTERS"

export const SIL_MODEL_DEVICES_QID_PRODUCT_LIST = "SIL_MODEL_DEVICES_QID_PRODUCT_LIST"
export const SIL_MODEL_DEVICES_QID_PRODUCT_IDS = "SIL_MODEL_DEVICES_QID_PRODUCT_IDS"
export const SIL_MODEL_DEVICES_QID_PRODUCT_SORT = "SIL_MODEL_DEVICES_QID_PRODUCT_SORT"
export const SIL_MODEL_DEVICES_QID_PRODUCT_FILTERS = "SIL_MODEL_DEVICES_QID_PRODUCT_FILTERS"

export const SIL_MODEL_DEVICES_QID_EXPANDED = "SIL_MODEL_DEVICES_QID_EXPANDED"
export const SIL_MODEL_DEVICES_QID_CLEAR_EXPANDED = "SIL_MODEL_DEVICES_QID_CLEAR_EXPANDED"

export const SIL_MODEL_DEVICES_QID_DATAPOINT_LIST = "SIL_MODEL_DEVICES_QID_DATAPOINT_LIST"
export const SIL_MODEL_DEVICES_QID_CLEAR_DATAPOINT_LIST = "SIL_MODEL_DEVICES_QID_CLEAR_DATAPOINT_LIST"

export const SIL_MODEL_DEVICES_QID_CALCULATION_METHOD = "SIL_MODEL_DEVICES_QID_CALCULATION_METHOD"
